import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutDetectionGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // Check if user is logged out
    const userData = localStorage.getItem('userData1');
    const userCode = localStorage.getItem('userCode');
    const eolUserCode = localStorage.getItem('eol_user_code');
    
    // If no user data exists, user is logged out
    if (!userData && !userCode && !eolUserCode) {
      // Update authentication state
      this.authService.setLoggedInState(false, null);
      
      // Navigate to home
      this.router.navigate(['/home']);
      
      // Refresh the page after a short delay
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }, 100);
      
      return false;
    }
    
    return true;
  }
} 